import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { PrintService } from 'src/app/services/print.service';
import { TABS } from 'src/app/dummy/tab';
import { MatDialog, MatSnackBar } from '@angular/material';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { CurriculumStore } from 'src/app/stores/resources/curriculum.store';
import { AddProgramReadingComponent } from '../add-program-reading/add-program-reading.component';

@Component({
  selector: 'app-program-reading',
  templateUrl: './program-reading.component.html',
  styleUrls: ['./program-reading.component.scss']
})
export class ProgramReadingComponent implements OnInit {
  @ViewChild('PRINT_TABLE', {static:false}) PRINT_TABLE: ElementRef;
  tabs: any = TABS.PROGRAM_LESSON;
  PROGRAM_KEY: any;
  LEVEL_KEY: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public store: CurriculumStore,
    private auth: AuthStore,
    public ps: PrintService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit() {
    this.route.params.subscribe((param) => {
      const { programKey, levelKey } = param;
      this.PROGRAM_KEY = programKey;
      this.LEVEL_KEY = levelKey;
      this.tabs = TABS.PROGRAM_LESSON.map(m => ({ path: `/programs/${this.PROGRAM_KEY}/${this.LEVEL_KEY}/${m.route}`, label: m.label }))
      this.store.fetchProgramLevelReading(this.PROGRAM_KEY, this.LEVEL_KEY);
    })
  }

  addItem(reading) {
    let dialogRef = this.dialog.open(AddProgramReadingComponent, {
      data: { READING:reading,PROGRAM_KEY: this.PROGRAM_KEY, LEVEL_KEY: this.LEVEL_KEY },
      panelClass: 'item-list-panel',
      width: '',
      height: '100vh',
      disableClose: true,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => { });
  }


  delete(reading) {
    const dialogRef = this.dialog.open(DeleteComponent, {
      data: { button: 'Remove', name: reading.name.name, title: 'Remove Reading' },
      panelClass: 'cs-overlay-panel',
      width: '35vw',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.store.removeReading(this.PROGRAM_KEY,this.LEVEL_KEY,reading.key, (success, res) => {
          this.snackBar.open("Reading has been removed successful.", "Done", { duration: 1000 });
        })
      }
    })
  }

}
